import React from "react";
import "./Content.css";
import { Link } from "react-scroll";
import me from "../../assets/me.png";

const Content = () => (
  <div className="content-section">
    <section className="content-home" id="content-home">
      <div className="content-title">
        <div>
          <p data-aos="fade-up" data-aos-delay="600">
            Hello
          </p>
          <h1 data-aos="fade-up" data-aos-delay="800">
            <span className="text-white">I am</span> Zaid Rajab
          </h1>
          <p data-aos="fade-up" data-aos-delay="1000">
            Full-stack Web Developer
          </p>
        </div>
        <Link id="scroll-to-about-me" to="about-me" href="#about-me">
          <div className="scroll-down"></div>
        </Link>
      </div>
      <img src={me} alt="Zaid Rajab" className="h-full w-1/4 self-end" />
    </section>
  </div>
);

export default Content;
